import React from "react";
import { FormGroup } from "../../../../components/form/models/models";
import * as Yup from "yup";

export const groupSupporrtNeedsForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "sectionHeader mb-5",
      },
      label: "Kindergarten Service",
    },
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      label: "Staff Ratio",
    },
    {
      type: "formGroup",
      classNameOpt: "staffRatio",
      fields: [
        {
          type: "field",
          fieldType: "number",
          key: "staffAmt",
          label: "Staff",
          props: {
            class: "p-inputtext p-component",
          },
          validation: Yup.number().required("A response is required"),
        },
        {
          type: "field",
          fieldType: "number",
          key: "childrenAmt",
          label: "Children",
          validation: Yup.number().required("A response is required"),
        },
      ],
    },

    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "fieldadv",
      },
      label:
        "Show the ratio of staff (teachers and educators) to children in the room e.g.: 1 staff to 11 children. Note: Additional Assistants are not counted as staff for this ratio.",
    },
    {
      type: "field",
      fieldType: "dropdown",
      key: "teacherExperience",
      label: "Teacher Experience",
      props: {
        options: [
          {
            label: "Graduate (1 - 2 yrs)",
            value: 0,
          },
          {
            label: "Early Career (3 - 5 yrs)",
            value: 1,
          },
          {
            label: "Mid Career (6 - 10 yrs)",
            value: 2,
          },
          {
            label: "Experienced (10+ yrs)",
            value: 3,
          },
          {
            label: "Information Not Provided",
            value: 4,
          },
        ],
      },
      validation: Yup.string().trim().required("A response is required"),
    },
    {
      type: "field",
      fieldType: "radio",
      key: "reasonableAdjustments",
      label: "Has the Early Childhood teacher made reasonable adjustments to support the Child's inclusion?",
      validation: Yup.string().trim().required("A response is required"),
      props: {
        options: [
          {
            label: "Yes",
            value: 1,
          },
          {
            label: "No",
            value: 0,
          },
        ],
      },
    },
    {
      type: "field",
      fieldType: "textarea",
      key: "reasonableAdjustmentsDescription",
      label: "Please specify",
      validation: Yup.string().trim().required("A response is required"),
      hideExpression: (formContext, values, model) => model.reasonableAdjustments == 1 || model.reasonableAdjustments == null,
    },
    {
      type: "field",
      fieldType: "radio",
      key: "existingSupport",
      label: "Is there existing KIS support in the room?",
      validation: Yup.string().trim().required("A response is required"),
      props: {
        options: [
          {
            label: "Yes",
            value: 1,
          },
          {
            label: "No",
            value: 0,
          },
        ],
      },
    },
    {
      type: "field",
      fieldType: "textarea",
      key: "existingSupportDescription",
      label: "Provide a brief description of the type of KIS support and hours (if reported)",
      validation: Yup.string().trim().required("A response is required"),
      hideExpression: (formContext, values, model) => model.existingSupport == 0 || model.existingSupport == null,
    },
    {
      type: "field",
      fieldType: "radio",
      key: "additionalSupport",
      label: "Is there any other additional support in the room?",
      validation: Yup.string().trim().required("A response is required"),
      props: {
        options: [
          {
            label: "Yes",
            value: 1,
          },
          {
            label: "No",
            value: 0,
          },
        ],
      },
    },
    {
      type: "field",
      fieldType: "textarea",
      key: "additionalSupportDescription",
      label: "Provide a brief description of the type of additional support and hours (if reported)",
      validation: Yup.string().trim().required("A response is required"),
      hideExpression: (formContext, values, model) => model.additionalSupport == 0 || model.additionalSupport == null,
    },
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "sectionHeader mt-5",
      },
      label: "Support Needs of the Whole Group",
    },
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "warning",
        Body: () => (
          <ul className="list-none pl-2 m-0">
            Group support levels are defined as follows:<li>0 – No other children in the group require additional support and guidance.</li>
            <li> 1 – Other children in the group require additional support and guidance at specific times during the kindergarten program. </li>
            <li> 2 – Other children in the group require additional support and guidance frequently during the kindergarten program.</li>
            <li>
              3 – A significant number of other children in the group require frequent additional support or guidance or other children require
              additional support at all times and their support needs have not already been considered through a KIS application.
            </li>
          </ul>
        ),
      },
      label: "",
    },
    {
      type: "field",
      fieldType: "dropdown",
      key: "groupSupportLevel",
      label: "Group support level",
      props: {
        options: [0, 1, 2, 3],
      },
      validation: Yup.string().trim().required("A response is required"),
    },
    {
      type: "field",
      fieldType: "textarea",
      key: "contextOfGroup",
      label: "Detail the context of the group",
      validation: Yup.string().trim().required("A response is required"),
    },
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "fieldadv",
      },
      label: "Specify the key points regarding the context of the group",
    },
  ],
};
